import { render, staticRenderFns } from "./visualizarRomaneio.vue?vue&type=template&id=16877ae5&scoped=true&"
import script from "./visualizarRomaneio.vue?vue&type=script&lang=js&"
export * from "./visualizarRomaneio.vue?vue&type=script&lang=js&"
import style0 from "./visualizarRomaneio.vue?vue&type=style&index=0&id=16877ae5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16877ae5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VDataTable,VFlex,VForm,VLayout,VSwitch,VTextField})
